import { gql } from '@apollo/client'

export const SEND_SALES_FOLLOWUP = gql`
  mutation requestSalesFollowup {
    requestSalesFollowup {
      success
    }
  }
`
